module.exports = __webpack_public_path__ + "static/blues-sub-header-8a955530dd1c175761f129259dc56ff2.jpg";